module.exports = __webpack_public_path__ + "img/bus-1.e3904611.png";